import { esc } from '@/utils/escape';

export function generateFaqHTML(data: any, settings: any): string {
  const items = (data.items || [])
    .map(
      (item: any) => `        <details class="faq-item">
          <summary>${esc(item.question)}</summary>
          <div class="faq-item__answer">${esc(item.answer)}</div>
        </details>`,
    )
    .join("\n");

  return `  <!-- FAQ -->
  <section class="faq" id="faq">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
        <p>${esc(data.subtitle)}</p>
      </div>
      <div class="faq__list">
${items}
      </div>
    </div>
  </section>`;
}
